import React from "react";

interface IconProps {
    className?: string;
  }

const ZoomInIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    id="Layer_23"
    height="512"
    viewBox="0 0 64 64"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 23"
    className={className}
  >
    <rect
      height="30"
      rx="4"
      width="30"
      x="17"
      y="17"
    />
    <path d="m3 18a2 2 0 0 0 2-2v-8.172l7.586 7.586a2 2 0 0 0 2.828-2.828l-7.586-7.586h8.172a2 2 0 0 0 0-4h-13a2 2 0 0 0 -2 2v13a2 2 0 0 0 2 2z" /><path d="m61 1h-13a2 2 0 0 0 0 4h8.172l-7.586 7.586a2 2 0 1 0 2.828 2.828l7.586-7.586v8.172a2 2 0 0 0 4 0v-13a2 2 0 0 0 -2-2z" /><path d="m16 59h-8.172l7.586-7.586a2 2 0 0 0 -2.828-2.828l-7.586 7.586v-8.172a2 2 0 0 0 -4 0v13a2 2 0 0 0 2 2h13a2 2 0 0 0 0-4z" /><path d="m61 46a2 2 0 0 0 -2 2v8.172l-7.586-7.586a2 2 0 0 0 -2.828 2.828l7.586 7.586h-8.172a2 2 0 0 0 0 4h13a2 2 0 0 0 2-2v-13a2 2 0 0 0 -2-2z" />
  </svg>
);

export default ZoomInIcon;
